import React from 'react';
import Modal from './modal';
import { WarningIcon } from 'assets/icons';

interface Props {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ModalWarningDocument = (props: Props) => {
  return (
    <Modal
      id='modal-warning-document'
      visible={props.visible}
      title='Documento generado automáticamente'
      onClose={props.onClose}
    >
      <img src={WarningIcon} />
      <p className='title'>Recomendamos sea revisado por un profesional</p>
      <p>
        El contenido corresponde a un esqueleto o plantilla preliminar. Antes de utilizarlo
        formalmente, recomendamos consultar con un abogado para verificar que se ajusta a su caso
        particular.
      </p>

      <div className='btn-container'>
        <button className='btn btn-accept' onClick={props.onConfirm}>
          Continuar
        </button>
        <button className='btn' onClick={props.onClose}>
          Cancelar
        </button>
      </div>
    </Modal>
  );
};

export default ModalWarningDocument;
